//close button for desktop view
document
  .querySelector(".desktop-only .wizzy-search-clear")
  .addEventListener("click", function (event) {
    event.preventDefault(); // Prevent the default action of the link
    const inputField = document.querySelector(".desktop-only .search__input");
    if (inputField) {
      inputField.value = ""; // Clear the input field
      inputField.focus(); // Optionally, focus back on the input field
    }
  });
//close button for mobile view
document
  .querySelector(".mobile-only .wizzy-search-clear")
  .addEventListener("click", function (event) {
    event.preventDefault(); // Prevent the default action of the link
    const inputField = document.querySelector(".mobile-only .search__input");
    if (inputField) {
      inputField.value = ""; // Clear the input field
      inputField.focus(); // Optionally, focus back on the input field
    }
  });
var wizzyLazyAssetUtils = {
  isWizzyLazyLoaded: false,
  isCollectionEnabled: false,
  wizzyStore: JSON.parse(window.localStorage.getItem("wizzy_store")) ?? false,
  collectionId:
    document
      .querySelector("[data-collection-id]")
      ?.getAttribute("data-collection-id") ?? false,
  productId:
    document
      .querySelector("[data-product-id]")
      ?.getAttribute("data-product-id") ?? false,
  pageHandle:
    document
      .querySelector("[data-page-handle]")
      ?.getAttribute("data-page-handle") ?? false,
  currentEle: null,
  searchInputIdentifiers: [],
  enableWizzyAssets() {
    if (!this.isWizzyLazyLoaded) {
      this.isWizzyLazyLoaded = true;
      if (
        typeof window.wizzyLazyAssets == "object" &&
        window.wizzyLazyAssets.hasOwnProperty("load") &&
        typeof window.wizzyLazyAssets.load == "function"
      )
        window.wizzyLazyAssets.load();
    }
  },
  isValidTargetEleToEnable(targetEle) {
    allCondition = [];
    let dom, type;
    for (let i in this.searchInputIdentifiers) {
      dom = this.searchInputIdentifiers[i].dom;
      type = this.searchInputIdentifiers[i].type;
      allCondition.push(
        targetEle.matches(dom) && targetEle.getAttribute("type") === type
      );
    }
    allCondition = allCondition.filter((x) => x);
    let condition = allCondition.length > 0;
    if (condition) this.currentEle = targetEle;
    return condition;

    return;
  },
  clickCondition(targetEle) {
    return wizzyLazyAssetUtils.isValidTargetEleToEnable(targetEle);
  },
  keyDownCondition(targetEle) {
    return wizzyLazyAssetUtils.isValidTargetEleToEnable(targetEle);
  },
  handleInitClick(e) {
    var self = wizzyLazyAssetUtils;
    let targetEle = e.target;
    if (self.clickCondition(targetEle) && !window.isWizzyLazyLoaded) {
      self.enableWizzyAssets();
      document.removeEventListener("click", self.handleInitClick);
    }
  },
  handleInitKeyDown(e) {
    var self = wizzyLazyAssetUtils;
    let targetEle = e.target;
    if (self.keyDownCondition(targetEle) && !window.isWizzyLazyLoaded) {
      self.enableWizzyAssets();
      document.removeEventListener("keydown", self.handleInitKeyDown);
    }
  },
  attachEvents() {
    var self = wizzyLazyAssetUtils;
    document.addEventListener("click", self.handleInitClick);
    document.addEventListener("keydown", self.handleInitKeyDown);

    window.addEventListener("onWizzyScriptLoaded", () => {
      window.wizzySearchInit();
    });

    window.addEventListener("onWizzyInit", () => {
      if (self.currentEle) {
        setTimeout(() => {
          self.currentEle.click();
        }, 10);
      }

      document.removeEventListener("click", self.handleInitClick);
    });
  },
  isOnValidaProductPage() {
    let self = wizzyLazyAssetUtils;
    return (
      self.wizzyStore &&
      typeof self.wizzyStore == "object" &&
      self.wizzyStore.hasOwnProperty("CLICKED_PRODUCTS") &&
      typeof self.wizzyStore["CLICKED_PRODUCTS"] == "object" &&
      self.wizzyStore["CLICKED_PRODUCTS"].hasOwnProperty(self.productId)
    );
  },
  isOnCollectionPage() {
    let self = wizzyLazyAssetUtils;
    return (
      self.isCollectionEnabled &&
      self.collectionId !== undefined &&
      self.collectionId !== "" &&
      self.collectionId !== null
    );
  },
  isNeedToAutoInitWizzy() {
    var self = wizzyLazyAssetUtils;
    return (
      self.pageHandle === "/pages/search" ||
      self.isOnValidaProductPage() ||
      self.isOnCollectionPage()
    );
  },
  init() {
    var self = wizzyLazyAssetUtils;
    this.attachEvents();
    if (!window.wizzyConfigUpdated) {
      let wizzyCategoryPageInterval = setInterval(() => {
        if (window.wizzyConfigUpdated) {
          clearInterval(wizzyCategoryPageInterval);
          this.setFromAppConfig();
          if (self.isNeedToAutoInitWizzy()) self.enableWizzyAssets();
        }
      }, 10);
    } else {
      this.setFromAppConfig();
      if (self.isNeedToAutoInitWizzy()) {
        self.enableWizzyAssets();
      }
    }
  },
  setFromAppConfig() {
    this.isCollectionEnabled =
      window.wizzyConfig?.common?.hasToReplaceCollectionPages ?? false;
    this.searchInputIdentifiers =
      window.wizzyConfig.common?.lazyDOMConfig?.searchInputIdentifiers ?? [];
  },
};

document.addEventListener("DOMContentLoaded", function () {
  wizzyLazyAssetUtils.init();
});

function checkWizzyConfigAndUpdate() {
  window.wizzyConfig &&
    (window.matchMedia("(max-width: 768px)").matches
      ? (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: ".mobile-only.mobile-search-wrapper input.search__input.field__input",
          type: "search",
        })
      : (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: "input#Search-In-Modal",
          type: "search",
        }),
    clearInterval(interval));
}
var interval = setInterval(checkWizzyConfigAndUpdate, 10);

function setWizzyCustomPlaceHolder() {
  let desktop, mobile_1, mobile_2;
  document.documentElement.clientWidth >= 768 &&
    ((desktop = document.querySelector("input#Search-In-Modal")),
    desktop.setAttribute("placeholder", "Search for ")),
    document.documentElement.clientWidth < 768 &&
      ((mobile_2 = document.querySelector(
        ".mobile-only.mobile-search-wrapper input.search__input.field__input"
      )),
      console.log("mobile2", mobile_2),
      mobile_2.setAttribute("placeholder", "Search for "));
  const phrases = ["Shampoo", "Serum", "Conditioner", "Hydrated Hair"];
  let index = 0,
    typingTimer;
  const typePhrase = function (placeholderText) {
      const phrase = phrases[index],
        len = phrase.length;
      let i = 0;
      typingTimer = setInterval(function () {
        if (i === len)
          clearInterval(typingTimer),
            setTimeout(function () {
              erasePhrase(placeholderText);
            }, 1e3);
        else {
          const currentText = placeholderText.getAttribute("placeholder");
          (placeholderText.placeholder = currentText + phrase.charAt(i)), i++;
        }
      }, 100);
    },
    erasePhrase = function (placeholderText) {
      const currentText = placeholderText.getAttribute("placeholder"),
        len = currentText.length;
      let i = len - 1;
      typingTimer = setInterval(function () {
        if (i === len - phrases[index].length - 1)
          clearInterval(typingTimer),
            index++,
            index === phrases.length && (index = 0),
            setTimeout(function () {
              typePhrase(placeholderText);
            }, 1e3);
        else {
          const newText = currentText.slice(0, i);
          placeholderText.setAttribute("placeholder", newText), i--;
        }
      }, 50);
    };
  document.documentElement.clientWidth < 768
    ? mobile_2 && typePhrase(mobile_2)
    : desktop && typePhrase(desktop);
}
setWizzyCustomPlaceHolder();

// Scripts level Theme customisation goes here
window.wizzyDomAutoDetector = true;
window.wizzyCustomUtils = {
  hideAutocomplete() {
    // console.log("$('.wizzy-search-input')====>", $(".wizzy-search-input"));
    $(".wizzy-search-input")[0].blur();
    // $('.wizzy-autocomplete-wrapper').css('display','none');
  },
  customTemplates: [
    "wizzy-search-results-product",
    "wizzy-autocomplete-topproducts",
    "wizzy-search-empty-results",
    "wizzy-search-wrapper",
  ],
  maxMobileScreenWidth: 768,
  isMobile() {
    return window.matchMedia(`(max-width: ${this.maxMobileScreenWidth}px)`)
      .matches;
  },
  registerWizzyEvent: function (eventName, callback) {
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents[eventName],
      function (payload = null) {
        let response = null;
        try {
          response = callback(payload);
        } catch (error) {
          console.log(error);
        }
        return response;
      }
    );
  },
  changeWizzyTemplate: function (name) {
    let newDiv = document.getElementById(name + "-new").text;
    let oldDiv = document.getElementById(name);
    oldDiv.text = newDiv;
  },
  replaceAllCustomTemplates: function () {
    for (let i in this.customTemplates) {
      this.changeWizzyTemplate(this.customTemplates[i]);
    }
  },
  setOffset(payload, desktop = 1000, mobile = 1200) {
    if (
      !payload.search.configs.pagination.infiniteScrollOffset ||
      (payload.search.configs.pagination.infiniteScrollOffset &&
        typeof payload.search.configs.pagination.infiniteScrollOffset !=
          "object")
    ) {
      payload.search.configs.pagination.infiniteScrollOffset = {};
    }
    payload.search.configs.pagination.infiniteScrollOffset.desktop = desktop;
    payload.search.configs.pagination.infiniteScrollOffset.mobile = mobile;
  },
  setSearchInput(payload) {
    let searchInputIdentifiers = [];
    //Custom Logic
    // if (this.isMobile()) {
    //     searchInputIdentifiers.push(
    //         {
    //             dom:".mobile-header #Search-In-Modal-Wizzy-Mobile",
    //             type:"search"
    //         }
    //     );
    //
    // }else{
    //
    //
    //     searchInputIdentifiers.push(
    //         {
    //             dom:".desktop-header .search-modal__form .search__input",
    //             type:"search"
    //         }
    //     );
    // }
    payload.common.lazyDOMConfig.searchInputIdentifiers =
      searchInputIdentifiers;
  },

  setAutcomplateTop() {
    let autocomplateEle = $(".wizzy-autocomplete-wrapper");
    let searchEle = $(".wizzy-search-input");

    let autocomplateHeight = [searchEle.offset().top + 45, "px"].join("");
    //console.log('autocomplateHeight======>',autocomplateHeight)
    //autocomplateEle.css('top',autocomplateHeight);
  },

  defaultWhenScriptLoaded: function () {
    this.replaceAllCustomTemplates();
    this.attachClickEvents();
    let self = this;
    if (!self.isMobile()) {
      $(document).on("scroll", function (e) {
        self.setAutcomplateTop();

        //console.log("=======$(document).scrollHeight",$(document)[0].scrollHeight);
        let autocomplateEle = $(".wizzy-autocomplete-wrapper");
        let headerEle = $(".section-header");
        let conditionFor = headerEle.hasClass("shopify-section-header-hidden");
        //console.log("headerEle=======>",);
        if (conditionFor) {
          autocomplateEle.css("display", "none");
          $("body").removeClass("wizzyHeaderTop");
        } else {
          $("body").addClass("wizzyHeaderTop");
        }
      });
    }
  },
  attachMutations() {
    this.attachHeaderMutations();
  },
  attachHeaderMutations() {
    // let self = this;
    // let ele = $(".section-header")[0];
    // let observer = new MutationObserver(function(mutations) {
    //     mutations.forEach(function(mutation) {
    //       let targetEle = $(mutation.target);
    //       if (targetEle.hasClass('shopify-section-header-hidden')) {
    //         $('body').removeClass('wizzyStickHeader');
    //       }else{
    //         $('body').addClass('wizzyStickHeader');
    //       }
    //       //console.log("targetEle================>",targetEle)
    //     });
    // });
    // observer.observe(ele, {
    //     attributes: true,
    //     attributeFilter: ['class']
    // });
  },
  whenScriptLoaded: function () {
    this.defaultWhenScriptLoaded();
    //Custom Logic
  },
  attachClickEvents() {
    //Custom Logic
    let self = this;
    if (!this.isMobile()) {
      //  $('body').on('click','.wizzy-search',function (e) {
      //    setTimeout(()=>{
      //    self.setAutcomplateTop();
      //    },50)
      // });
    }

    if (this.isMobile())
      $("body").on("click", '.search__input[name="q"]', function (e) {
        if (!$(".wizzy-search-form-wrapper").hasClass("mobileTapped")) {
          $(".wizzy-search-form-wrapper").addClass("mobileTapped");
          $("#wizzy-search-input").focus();
          $("#wizzy-search-input").click();
        }
      });
  },
  beforeFilter() {
    let self = this;
    self.registerWizzyEvent("BEFORE_FILTERS_EXECUTED", (payload) => {
      //Custom Logic

      return payload;
    });
  },
  beforeSearch() {
    let self = this;
    self.registerWizzyEvent("BEFORE_SEARCH_EXECUTED", (payload) => {
      //Custom Logic
      $(".collection-hero__title").css("display", "none");
      $(".page-width").css("max-width", "unset");

      //payload.filters.response.payload.configs = {configs:{keepOpenedInMobileAfterApply:false, displayAsDrawer:true, keepOpenedInDesktopAfterApply:true, drawerPosition:"right"}}
      return payload;
    });
  },
  beforeInit: function () {
    let self = this;
    this.registerWizzyEvent("BEFORE_INIT", (payload) => {
      self.setOffset(payload, 600, 1900);
      //self.setSearchInput(payload);
      //payload.search.configs.general.minQueryLength=1;
      //Custom Logic;
      payload.filters = {
        configs: {
          keepOpenedInMobileAfterApply: true,
          displayAsDrawer: false,
          keepOpenedInDesktopAfterApply: false,
          drawerPosition: "left",
        },
      };

      if (this.isMobile()) {
        payload.common.lazyDOMConfig.searchInputIdentifiers.push({
          dom: '.mobile-only.mobile-search-wrapper [name="q"]',
          type: "search",
        });
        payload.search.configs.general.noOfProducts =
          payload.search.configs.general.noOfProducts - 1;
      } else {
        //payload.search.configs.general.noOfProducts=payload.search.configs.general.noOfProducts-1;
      }

      setTimeout(() => {
        $(".wizzy-search-input").attr("autocomplete", "off");
      });

      return payload;
    });
  },
  afterTransform: function () {
    let self = this;
    self.registerWizzyEvent("AFTER_PRODUCTS_TRANSFORMED", (productList) => {
      productList = productList.map((x) => {
        //Custom Logic

        x.sellingPrice = x.sellingPrice.replaceAll(",", "");
        x.sellingPrice = parseFloat(x.sellingPrice).toFixed(0);
        if (x.discountPercentage) {
          x.price = x.price.replaceAll(",", "");
          x.price = parseFloat(x.price).toFixed(0);
        }
        x.hasVariants = false;
        x.attributes.forEach((y) => {
          switch (y.id) {
            case "product_product_tag_custom":
              x.productIngredient = y.values[0].value[0];
              break;

            case "product_product_type":
              x.productType = y.values[0].value[0];
              break;

            case "product_combo_variant_size_custom":
              x.productComboSize = y.values[0].value[0];
              break;

            case "product_product_tag_custom":
              x.product = y.values[0].value[0];
              break;

            case "product_handle":
              x.handle = y.values[0].value[0];
              break;

            case "product_variant_prices":
              x.hasVariants = false;
              if (y.values.length > 1) {
                //   x.hasVariants=true;
                x.minPrice = 0;
                x.maxPrice = 0;
                y.values.forEach((z) => {
                  if (!x.minPrice || x.minPrice > z.value[0]) {
                    x.minPrice = z.value[0];
                  }
                  if (!x.maxPrice || x.minPrice < z.value[0]) {
                    x.maxPrice = z.value[0];
                  }
                });
              }
              break;
          }
        });

        return x;
      });

      return productList;
    });
  },
  viewRendered: function () {
    let self = this;
    this.registerWizzyEvent("VIEW_RENDERED", (payload) => {
      //Custom Logic

      if (payload.data.api == "autocomplete" && !self.isMobile()) {
        self.setAutcomplateTop();
      }
      if (payload.data.api == "search" || payload.data.api == "filter") {
        if (self.isMobile()) {
          $(".wizzy-search-back")[0].click();
          $(".wizzy-autocomplete-wrapper").css({ display: "none" });
        }

        if (payload.data.response.payload.total === 1) {
          $("body").addClass("wizzy-has-no-sorting");
        } else {
          $("body").removeClass("wizzy-has-no-sorting");
        }
      }
      return payload;
    });
  },
  cacheResultRendered() {
    let self = this;
    self.registerWizzyEvent("PRODUCTS_CACHED_RESULTS_RENDERED", () => {
      //Custom Logic
    });
  },
  init() {
    let wizzyCustomInitProcess = [
      "whenScriptLoaded",
      "attachMutations",
      "beforeInit",
      "beforeSearch",
      "beforeFilter",
      "afterTransform",
      "viewRendered",
      "cacheResultRendered",
    ];
    for (let i in wizzyCustomInitProcess) {
      if (typeof this[wizzyCustomInitProcess[i]] == "function") {
        this[wizzyCustomInitProcess[i]]();
      }
    }
  },
};

const ignoreQueryList = [
    'sex', 'intercourse', 'intimacy', 'coitus', 'lovemaking', 'coupling', 'gender', 'sensuality', 'reproduction', 
    'sexual activity', 'romance',
    'chair', 'seat', 'stool', 'armchair', 'recliner', 'bench', 'furniture', 'throne', 'office chair', 'high chair', 
    'rocking chair',
    'shit', 'crap', 'feces', 'excrement', 'dung', 'stool', 'waste', 'filth', 'bowel movement', 'manure', 'nonsense',
    'fucker', 'jerk', 'idiot', 'scoundrel', 'bastard', 'asshole', 'insult', 'offensive term', 'derogatory term',
    'sucker', 'fool', 'gullible person', 'dupe', 'chump', 'mark', 'pushover', 'victim', 'suckerfish', 'enthusiast'
];


window.onWizzyScriptLoaded = function () {
  // console.log("===============wizzyLoaded==============");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (payload) {
      // console.log(payload, "<<================api payload");

      if (payload.api == "autocomplete" || payload.api == "variation")
        return payload;
      facets = payload?.response?.payload?.facets;

      facets.forEach((facet) => {
        if (Array.isArray(facet.data)) {
          facet.data.forEach((facetInfo) => {
            facetInfo.label = facetInfo.label.replace(/-/g, " ");
          });
        }
      });
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      var element = $(".page-width.scroll-trigger");
      if (
        window.wizzyConfig.common.isOnCategoryPage == true &&
        element.hasClass("animate--slide-in")
      ) {
        element.removeClass("animate--slide-in");
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload, "<<================WIZ api payload");

      var query = payload.q;
      if (query) {
        query = query.toLowerCase();
        if (ignoreQueryList.includes(query)) {
          payload.q = "abcdefghijkl";
        }
      }
      
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      console.log(payload, "<<================Wiz api payload");

      var query = payload.q;
      if (query) {
        query = query.toLowerCase();
        if (ignoreQueryList.includes(query)) {
          payload.q = "abcdefghijkl";
        }
      }
      
      return payload;
    }
  );
  
  wizzyCustomUtils.init();
};

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAdd-"]');
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener.querySelector(".loading__spinner").classList.remove("hidden");

        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]'
            );
            this.productElement.classList.forEach((classApplied) => {
              if (
                classApplied.startsWith("color-") ||
                classApplied === "gradient"
              )
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll("script").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML)
          );
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector(
          "variant-radios,variant-selects"
        );
        if (!variantPicker) return;

        variantPicker.setAttribute("data-update-url", "false");
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector(
          "pickup-availability"
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector("product-modal");
        if (productModal) productModal.remove();

        const modalDialog =
          this.productElement.querySelectorAll("modal-dialog");
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          );
        this.productElement
          .querySelectorAll("variant-selects, variant-radios, product-info")
          .forEach((element) => {
            element.dataset.originalSection = sectionId;
          });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector(".product");
        const desktopColumns = product.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) =>
          img.setAttribute("sizes", mediaImageSizes)
        );
      }
    }
  );
}
